import { DashboardOpenMode } from "MyDashboards/state/types";
import Loader from "qpr-base/ui/components/Loader";
import React from "react";

type TPlainTab = () => JSX.Element;
type TSelectableTab = (props: {
  selected?: string;
  mode?: DashboardOpenMode;
}) => JSX.Element;
const Page = (
  props: React.PropsWithChildren<{
    isLoading?: boolean;
    Toolbar: TPlainTab | TSelectableTab;
    mode?: DashboardOpenMode;
    className?: string;
  }>
) => {
  return (
    <div style={{ width: "100%" }} className={props.className}>
      <props.Toolbar mode={props.mode} />
      {props.isLoading ? <Loader /> : null}
      {!props.isLoading ? <div> {props.children}</div> : null}
    </div>
  );
};

export default Page;
